import { render, staticRenderFns } from "./RiskEarlyWarning.vue?vue&type=template&id=794f4112&scoped=true"
import script from "./RiskEarlyWarning.vue?vue&type=script&lang=js"
export * from "./RiskEarlyWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f4112",
  null
  
)

export default component.exports